const resources = {
    pageTitle: 'Allow Access to your Beauty Insider account',
    whatCanDo: 'What ChatGPT can do',
    permission1: 'Recommend products you\'ll love',
    permission2: 'Find and re-shop favorites faster',
    permission3: 'Discover brands and routines that fit you',
    allowAccessButton: 'Allow Access',
    cancelButton: 'Cancel',
    manageAccessText: 'Review or remove access anytime in your ChatGPT settings by disconnecting the Sephora app.',
    privacyPrefix: 'For details on how ChatGPT uses your data, see the',
    chatGPTPrivacyPolicy: 'ChatGPT Privacy Policy',
    privacyMiddle: '. For how Sephora protects your information, see the',
    sephoraPrivacyPolicy: 'Sephora Privacy Policy',
    privacyEnd: '.',
    sessionIdNotFound: 'Session ID not found. Please restart the authorization flow.',
    authorizationFailed: 'Authorization failed. Please try again.'
};

export default function getResource(label) {
    return resources[label];
}
